import React from 'react';
import { EMeasureUnit } from '../../../../../../../../store/commomTypes';
import { IOpenOrderQuantities } from '../../../../../../../../store/ducks/long-steel-orders/types';
import { Container } from './styles';

interface IProductStatusDetailsTableProps {
  quantities: IOpenOrderQuantities;
}

const ProductStatusDetailsTable: React.FC<IProductStatusDetailsTableProps> = ({
  quantities
}) => {
  const getVolumeValueToShow = (
    field: string,
    measureUnit?: EMeasureUnit
  ): string => {
    const value =
      measureUnit === EMeasureUnit.KG || measureUnit === EMeasureUnit.T
        ? Number(field).toFixed(2).toString().replace('.', ',')
        : Number(field);

    return `${value} ${measureUnit || quantities.requestedMeasureUnit}`;
  };

  return (
    <Container>
      {Number(quantities.billedQuantity) > 0 && (
        <div>
          <div>
            <span className="billed"></span>
            <span>Faturado:</span>
          </div>
          <span>
            {getVolumeValueToShow(
              quantities.billedQuantity,
              quantities.billedMeasureUnit
            )}
          </span>
        </div>
      )}

      {Number(quantities.deliveryQuantity) > 0 && (
        <div>
          <div>
            <span className="delivery"></span>
            <span>Em remessa:</span>
          </div>
          <span>
            {getVolumeValueToShow(
              quantities.deliveryQuantity,
              quantities.deliveryMeasureUnit
            )}
          </span>
        </div>
      )}

      {Number(quantities.shipmentQuantity) > 0 && (
        <div>
          <div>
            <span className="shipment"></span>
            <span>Em carregamento:</span>
          </div>
          <span>
            {getVolumeValueToShow(
              quantities.shipmentQuantity,
              quantities.shipmentMeasureUnit
            )}
          </span>
        </div>
      )}

      {Number(quantities.pendingQuantity) > 0 && (
        <div>
          <div>
            <span className="pending"></span>
            <span>Saldo:</span>
          </div>
          <span>
            {getVolumeValueToShow(
              quantities.pendingQuantity,
              quantities.pendingMeasureUnit
            )}
          </span>
        </div>
      )}
    </Container>
  );
};

export default ProductStatusDetailsTable;
